import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { createClient } from "graphql-ws";

const hasSubscriptionOperation = ({
  query: { definitions },
}: {
  query: { definitions: readonly { kind: string; operation?: string }[] };
}) =>
  definitions.some(
    ({ kind, operation }) => kind === "OperationDefinition" && operation === "subscription"
  );

const graphqlWsLink = new GraphQLWsLink(
  createClient({
    url: process.env.ANYCABLE_WEBSOCKET_URL || "",
  })
);

export { hasSubscriptionOperation, graphqlWsLink };
